export const fr = {
    'titles': {
        settings: 'Paramètrage',
        support: 'Support et aide',
        dashboard: 'Dashboard',
        organisations: 'Organisations',
        network: 'Réseau',
        organisationsList: 'Organisations',
        clientList: 'Clients',
        commercialList: 'Commerciaux',
        domainList: 'Secteur d\'activités',
        functionnalityList: 'Fonctionnalités',
        moduleList: 'Modules',
        typePacksList: 'Types des packs',
        packsList: 'Configuration packs',

        add: 'Ajouter',
        update: 'Modifier',
        generalInfo: 'Informations générales',

        domainListExpression: 'Liste des secteurs d\'activités',
        domainAddExpression: 'Ajouter un secteur d\'activité',
        domainEditExpression: 'Modifier un secteur d\'activité',
        commercialListExpression: 'Liste des commerciaux',
        commercialAddExpression: 'Ajouter un commercial',
        commercialEditExpression: 'Modifier un commercial',
        commercialDetailExpression: 'Détails d\'un commercial',
        placeholderNameDomain: 'Nom du secteur d\'activité',
        placeholderUrlDomain: 'URL',
        errorNameDomain: 'Le nom du secteur d\'activité est obligatoire.',
        errorLengthNameDomain(val = 0) {
            return `Le nom du secteur d'activité doit contenir au minimum ${val} lettres.`;
        },
        errorUrlDomain: 'L\'url du secteur d\'activité est obligatoire.',
        errorFormatUrlDomain: 'L\'url du secteur d\'activité doit être sous la forme http://google.com',
        deleteDomainSuccesTitle: 'Secteur d\'activité supprimé avec succès',
        deletePackCountryDomainSuccessTitle: 'Pack supprimé avec succès',
        deleteCommercialSuccesTitle: 'Commercial Supprimé avec succès',
        deleteClientSuccesTitle: 'Client Supprimé avec succès',
        deleteFunctionalitySuccesTitle: 'Functionnalité Supprimée avec succès',

        moduleListExpression: 'Liste des modules',
        moduleAddExpression: 'Ajouter un module',
        moduleEditExpression: 'Modifier un module',
        placeholderNameModule: 'Nom du module ',
        placeholderUrlModule: 'URL ',
        errorNameModule: 'Le nom du module est obligatoire.',
        errorLengthNameModule(val = 0) {
            return `Le nom du module doit contenir ${val} lettres.`;
        },
        errorUrlModule: 'L\'url du module est obligatoire.',
        deleteModuleSuccesTitle: 'Module supprimé avec succès',
        deleteModuleErrorTitle: 'Module est affecté à plusieurs fonctionnalités',
        deleteDomainErrorTitle: 'Secteur d\'activité possède plusieurs packs',
        deleteFunctionalityErrorTitle: 'Fonctionnalité possède plusieurs packs',
        deleteTypePackErrorTitle: 'Type possède plusieurs packs',
        configureTypePackSuccessTitle: 'Ordre type est fait avec succés',

        typePackListExpression: 'Liste des type packs',
        typePackAddExpression: 'Ajouter un type pack',
        typePackEditExpression: 'Modifier un type pack',
        placeholderNameTypePack: 'Nom',
        placeholderOrderTypePack: 'Ordre',
        errorNameTypePack: 'Le nom du type de pack est obligatoire.',
        errorLengthNameTypePack(val = 0) {
            return `Le nom du type pack doit contenir ${val} lettres.`;
        },
        errorFormatOrderTypePack: 'L\'order doit être numérique',
        errorOrderTypePack: 'L\'ordre du typePack est obligatoire.',
        deleteTypePackSuccesTitle: 'TypePack supprimé avec succès',

        functionalityListExpression: 'Liste des fonctionnalités',
        functionalityAddExpression: 'Ajouter une fonctionnalité',
        placeholderNameFunctionality: 'Nom ',
        placeholderModuleFunctionality: 'Module ',
        placeholderDetailFunctionality: 'Detail ',
        functionalityEditExpression: 'Modifier une fonctionnalité',
        errorNameFunctionality: 'Le nom de la fonctionnalité est obligatoire.',
        errorModuleFunctionality: 'Le module de la fonctionnalité est obligatoire.',
        placeholderDetailsFunctionality: 'Détails',
        errorDetailsFunctionality: 'Le detail de la fonctionnalité est obligatoire.',
        errorLengthNameFunctionality(val = 0) {
            return `Le nom de la fonctionnalité doit contenir ${val} lettres.`;
        },
        organisationListExpression: 'Liste des organisations',
        organisationAddExpression: 'Ajouter une organisation',
        organisationEditExpression: 'Modifier une organisation',
        payment: 'Paiement',
        paymentAdd: 'Terminer le paiement',
        clientInfo: 'Information client',
        organisationInfo: 'Information organisation',
        organisationName: 'Nom de l\'organisation',
        organisationAddress: 'Adresse de l\'organisation',
        timeZone: 'Fuseau horaire',
        organisationTva: 'N° TVA',
        taxRegistrationNumber: 'Matricule fiscale',
        cnssAffiliation: 'Affiliation CNSS',
        commercialRegister: 'Registre commercial',
        WebSite: 'Site web',
        activityArea: 'Secteur d\'activité',
        packsInfo: 'Information pack',
        typePack: 'Type pack',
        pricePack: 'Prix pack',
        subscriptionPeriod: 'Période abonnement (jour)',
        trialPeriod: 'Période d\'essai (jour)',
        numberOfHoursOfSupport: 'Nombre d\'heures de support',
        numberOfUsers: 'Nombre users',
        firstNameCommercial: 'Prénom du commercial',
        lastNameCommercial: 'Nom du commercial',
        adresseEmailCommercial: 'Adresse email',
        societyNameCommercial: 'Nom de la société',
        placeholderPays: 'Pays',
        statusCommercial: 'État du commercial',
        fieldIsRequired: 'Ce champ est obligatoire',
        invalidEmail: 'Invalid email',
        errorLengthName(val = 0) {
            return `Ce champ doit contenir au minimum ${val} caractère.`;
        },
        errorLengthNameMax(val = 0) {
            return `Ce champ doit contenir au maximum ${val} caractère.`;
        },
        errorFormatUrl: 'Ce champ doit être sous la forme http://google.com',
        errorFormatNumeric: 'Ce champs doit être un nombre positif',
        firstName: 'Prénom du client',
        lastName: 'Nom du client',
        phone: 'Numéro de téléphone',
        country: 'Pays',
        currency: 'Devise',
        language: 'Langue',
        choiceClient: 'Choisir un client',
        generatePromoCode: ' Générer un code promo',
        next: 'Suivant',
        isFree: 'Gratuit',
        isUnlimited: 'Illimité',
        previous: 'Précédent',

        placeholderDomainPack: 'Secteur d\'activité',
        placeholderCountryPack: 'Pays',

        packConfigTitle: 'Configurer un pack',
        defaultPack: 'Pack par défaut',

        hasValue: 'Possède une valeur',
        dontHaveValue: 'Ne possède pas une valeur',
        FunctionalyInfo: 'Fonctionnalités des packs',
        addOrganisationMessage: 'Organisation ajouté avec succès',
        addClientMessage: 'Client ajouté avec succès',
        addCommercialMessage: 'Commercial ajouté avec succès',
        updateClientMessage: 'Client modifié avec succès',
        updateCommercialMessage: 'Commercial modifé avec succès',
        updaterganisationMessage: 'Organisation modifié avec succès',
        clientListExpression: 'Liste des clients',
        clientAddExpression: 'Ajouter un client',
        clientEditExpression: 'Modifier un client',
        clientDetailExpression: 'Détails du client',
        deleterganisationMessage: 'Organisation supprimé avec succès',
        confirmDeleterganisationMessage: 'Voulez-vous vraiement supprimer cette organisation ?',
        confirmDeleteClientMessage: 'Voulez-vous vraiement supprimer ce client ?',
        confirmDeleteCommercialMessage: 'Voulez-vous vraiement supprimer ce commercial ?',

        Functionality: 'Fonctionnalité',
        Details: 'Détails',
        Value: 'Valeur',
        Configurate: 'Configurer',
        pleaseSelectCountryDomain: 'Veuillez sélectionner un type pack',
        cannotDeleterganisationMessage: 'Vous ne pouvez pas supprimer cette organisation',
        cannotPaySubscriptionMessage: 'Vous devez contacter l\'administration',

        errorMinValue(val = 0) {
            return `La valeur minimale est ${val} .`;
        },
        errorMaxValue(val = 0) {
            return `La valeur maximale est ${val} .`;
        },
        profile: 'Profil',
        oldpassword: 'Mot de passe courant',
        newpassword: 'Nouveau mot de passe',
        newRetypedPassword: 'Confirmer nouveau mot de passe',
        profileUpdateExpression: 'Modifier mon profil',
        firstNameAdmin: 'Prénom de l\'administrateur',
        lastNameAdmin: 'Nom de l\'administrateur',
        pleaseTapYourPassword: 'Merci de faire entrer votre mot de passe',
        confirmation: 'Confirmation',
        toConfirm: 'Confirmer',
        toCancel: 'Annuler',
        passwordInvalid: 'Le mot de passe est incorrect',
        invalidPasswordMessage: 'Le mot de passe doit contenir un nombre, une lettre majuscule et une lettre minuscule',
        successProfilMessage: 'Votre profil a été modifié avec succès',
        passwordNotSame: 'Les deux mots de passes ne sont pas égaux',
        decimal: 'Le prix doit être un decimal',
        checkDecimalNumber: 'Il faut respecter le nombre de chiffres selon ta devise',
        updatePassword: 'Changer mon mot de passe',
        confirmationMail: 'Un mail de confirmation a été envoyé au commercial',
        updatePackCountryDomain: 'Pack est mis à jour avec succès',
        personalInfo: 'Informations personnelles',
        activateCompte: 'Activer mon compte',
        examplePhoneNumber: 'Exemple :',
        emailExist: 'Cette adresse e-mail est déjà prise!',
        recoveryCode: 'Code de récupération',
        sendEmailrecoveryCode: 'Entrez votre e-mail et le code de récupération vous sera envoyé!',
        alreadyHaveACode: 'Tu as déjà un code?',
        send: 'Envoyer',
        signInHere: 'Se connecter ici',
        rememberIt: 'Souviens toi ?',
        resetPassword: 'Réinitialiser le mot de passe',
        recoveryCodeAndResetPassword: 'Entrez votre code de récupération et réinitialisez votre mot de passe!',
        errorLengthCode(val = 0) {
            return `Le champ code doit contenir ${val} caractères.`;
        },
        codeWrong: 'Le code est faux.',
        rememberYourPassword: 'Souvenez-vous de votre mot de passe?',
        enterNewPassword: 'Entrez un nouveau mot de passe',
        enterConfirmNewPassword: 'Entrez Confirmer le nouveau mot de passe',
        enterRecoveryCode: 'Entrez le code de récupération',
        recoveryCodeHasBeenSentToYourEmail: 'Le code de récupération a été envoyé à votre adresse e-mail.',
        invalidCredentials: 'Les informations d\'identification sont invalides.',
        addClientErrorMessage: 'Cet e-mail est déjà pris!',
        emptyData: 'Aucune données à afficher',
        active: 'Activé',
        light: 'Light',
        displayed: 'Displayed',
        acceptPayment: 'Accepter virement',
        declinePayment: 'Annuler virement',
        confirmUpdateTitle: 'Confirmation modification',
        confirmUpdateMessage: 'Voulez vous confirmé la modification de l\'ordre?',
        unlimited: 'Illimité',
        NoFreePeriod: 'Pas de période d\'essai',
        free: 'Gratuit',
        days: 'jours',
        testPeriod: 'Période d\'essai : ',
        nbUsers: 'Nombre utilisateurs : ',
        nbSupport: 'Nombre d\'heures de support : ',
        cannotDeleteClientMessage: 'Vous ne pouvez pas supprimer ce client',
        yourPasswordHasBeenChanged: 'Votre mot de passe a été changé.',
        invalidPhoneNumber: 'Le numéro de téléphone n\'est pas valide',
        invalidVerificationCode: 'Le code de vérification n\'est pas valide',
        errorSendingVerificationCode: 'Échec de l\'envoi de sms. Veuillez réessayer plus tard.',
        pleaseAddCustomers: 'Veuillez ajouter des clients',
        noCustomersToShowPleaseAddANew: 'Aucun client à afficher, veuillez ajouter un nouveau client',
        checkExistLabel: 'Nom déja existe',
        postalCode: 'Code postal',
        city: 'ville',
        additionalAddress: 'Complément d\'adresse',
        numSIRET: 'Numéro SIRET',
        unpaid: 'non payé',
        paid: 'payé',
        cannotAddOperationMessage: 'L\'opération a échoué',
        successPayment: 'Paiement est fait avec succès',
        errorPayment: 'Paiement échoué',
        cardNotSupported: 'Votre carte n\'est pas prise en charge',
        card3DSecure: 'Une authentification 3D Secure est obligatoire!',
        cardInsufficientFunds: 'Votre carte ne dispose pas de fonds suffisants!',
        cancelPayment: 'Paiement est annulé avec succès',
        loading: 'Loading...',
        functionalityPack: 'Fonctionnalités',
        noValue: 'Aucune valeur',
        logs: 'Logs',
        organisationPack: "Pack",
        organisationMontant: "Montant",
        organisationPaymentState: "Etat du paiement",
        organisationStartDate: "Date début",
        organisationEndDate: "Date Fin",
        organisationLinkToStark: "Lien vers Stark",
        starkInstanceInProgress: "En cours de préparation"

    }
};
